import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import API_CONFIG from '../config/api';

const PRESTADOR_TOKEN_KEY = 'prestadorSessionToken';
const PRESTADOR_KEY = 'prestador';

const PrestadorAuthContext = createContext({
  prestador: null,
  loginPrestador: async () => false,
  setPrestadorSession: () => {},
  logoutPrestador: () => {},
});

export function PrestadorAuthProvider({ children }) {
  const [prestador, setPrestador] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem(PRESTADOR_KEY);
    const token = localStorage.getItem(PRESTADOR_TOKEN_KEY);
    if (saved && token) {
      try {
        setPrestador(JSON.parse(saved));
      } catch {
        localStorage.removeItem(PRESTADOR_KEY);
        localStorage.removeItem(PRESTADOR_TOKEN_KEY);
      }
    }
  }, []);

  const setPrestadorSession = useCallback((token, prestadorData) => {
    if (!token || !prestadorData) return;
    localStorage.setItem(PRESTADOR_TOKEN_KEY, token);
    localStorage.setItem(PRESTADOR_KEY, JSON.stringify(prestadorData));
    setPrestador(prestadorData);
  }, []);

  const loginPrestador = useCallback(async (email, cnpj, senha) => {
    try {
      const res = await fetch(`${API_CONFIG.BACKEND_URL}/api/auth/prestador/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email || undefined, cnpj: cnpj || undefined, senha })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data.error || 'Erro ao autenticar prestador');
      }
      setPrestadorSession(data.token, data.prestador);
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }, [setPrestadorSession]);

  const logoutPrestador = useCallback(() => {
    localStorage.removeItem(PRESTADOR_TOKEN_KEY);
    localStorage.removeItem(PRESTADOR_KEY);
    localStorage.removeItem('godModeAudit');
    setPrestador(null);
  }, []);

  return (
    <PrestadorAuthContext.Provider
      value={{ prestador, loginPrestador, setPrestadorSession, logoutPrestador }}
    >
      {children}
    </PrestadorAuthContext.Provider>
  );
}

export function usePrestadorAuth() {
  return useContext(PrestadorAuthContext);
}

export function getPrestadorToken() {
  return localStorage.getItem(PRESTADOR_TOKEN_KEY);
}

export function prestadorFetch(url, options = {}) {
  const fullUrl = url.startsWith('http') ? url : `${API_CONFIG.BACKEND_URL}${url}`;
  const token = getPrestadorToken();
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  return fetch(fullUrl, { ...options, headers });
}
